import { Modal as AntModal } from "antd";
import { useTranslation } from "react-i18next";
import { EntProduct } from "../../../../../models/handBooks/product";
import {
  useAddProductsMutation,
  useDeleteProductsMutation,
  useEditProductsMutation }
  from "../../../../../redux/api/handBooksApi/chemicalization/production";

interface ProductRequest {
  id?: number;
  nameKy: string;
  nameRu: string;
  categoryId?: number | null;
  varieties?: Array<{
    nameKy: string;
    nameRu: string;
    childId?: number | null;
  }>;
}

export const useTypeProduct = (Modal: typeof AntModal, onSuccess: () => void) => {
  const { t } = useTranslation();
  const [addProduct] = useAddProductsMutation();
  const [editProduct] = useEditProductsMutation();
  const [deleteProduct] = useDeleteProductsMutation();

  const onAddProduct = async (data: EntProduct): Promise<boolean> => {
    try {
      console.log('Добавление категории:', data);
      const request: ProductRequest = {
        nameKy: data.nameKy || '',
        nameRu: data.nameRu || '',
        categoryId: data.categoryId,
        varieties: data.varieties?.map(variety => ({
          nameKy: variety.nameKy || '',
          nameRu: variety.nameRu || ''
        }))
      };
      
      console.log('Отправляемый запрос:', request);
      const response = await addProduct(request).unwrap();
      if (response.success) {
        onSuccess();
        return true;
      }
      return false;
    } catch (e: any) {
      console.error('Ошибка при добавлении:', e);
      Modal.error({
        title: t("msg.error"),
        content: e.data?.message ?? String(e.message),
      });
      return false;
    }
  };

  const onEditProduct = async (data: EntProduct): Promise<boolean> => {
    try {
      console.log('Редактирование категории:', data);
      if (!data.id) {
        throw new Error('ID is required for editing');
      }

      const request: ProductRequest = {
        id: data.id,
        nameKy: data.nameKy || '',
        nameRu: data.nameRu || '',
        categoryId: data.categoryId,
        varieties: data.varieties?.map(variety => ({
          nameKy: variety.nameKy || '',
          nameRu: variety.nameRu || ''
        }))
      };

      console.log('Отправляемый запрос на редактирование:', request);
      const response = await editProduct(request).unwrap();
      if (response.success) {
        onSuccess();
        return true;
      }
      return false;
    } catch (e: any) {
      console.error('Ошибка при редактировании:', e);
      Modal.error({
        title: t("msg.error"),
        content: e.data?.message ?? String(e.message),
      });
      return false;
    }
  };

  const onDeleteProduct = async (data: EntProduct) => {
    if (!data.id) {
      Modal.error({
        title: t("msg.error"),
        content: "ID is required for deletion",
      });
      return;
    }

    Modal.confirm({
      title: t("general.modal_confirm"),
      content: t("msg.confirm_delete"),
      onOk: async () => {
        try {
          const response = await deleteProduct(data.id as number).unwrap();
          if (response.success) {
            onSuccess();
          }
        } catch (e: any) {
          Modal.error({
            title: t("msg.error"),
            content: e.data?.message ?? String(e.message),
          });
        }
      },
    });
  };

  return {
    onAddProduct,
    onEditProduct,
    onDeleteProduct,
  };
};
